import React, { HTMLProps, useRef } from 'react'
import { mergeProps, useButton } from 'react-aria'
import styled from 'styled-components'
import { Box, BoxType } from '../box'
import { AriaProps } from '../../components/types'
import { splitAriaProps } from '../../components/helpers'

const StyledBox = styled(Box)`
  cursor: pointer;

  :disabled {
    cursor: auto;
  }

  :focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows['border/focus-indicator']};
  }
`
export interface Props
  extends BoxType,
    Omit<
      HTMLProps<HTMLButtonElement>,
      'onClick' | 'as' | 'color' | 'height' | 'size' | 'width' | 'type'
    > {
  ariaProps?: AriaProps
  onClick?: AriaProps['onPress']
  type?: 'button' | 'submit' | 'reset'
}

export const UnstyledButton = ({ onClick, disabled, ...props }: Props) => {
  const { elementRef, domProps, reactAriaProps } = splitAriaProps(props.ariaProps)
  const fallbackRef = useRef<HTMLButtonElement>(null)
  const ref = elementRef ?? fallbackRef
  const { buttonProps } = useButton(
    { onPress: onClick, isDisabled: disabled, type: props.type ?? 'button', ...reactAriaProps },
    ref
  )

  return (
    <StyledBox
      as='button'
      type='button'
      p={0}
      m={0}
      borderRadius='none'
      border='none'
      bg='transparent'
      textAlign='start'
      display='block'
      {...mergeProps(props, buttonProps, domProps)}
      // https://github.com/styled-components/styled-components/issues/4331
      ref={ref}
    />
  )
}
